/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SkillCategoryRow_company = {
    readonly id: string;
    readonly skillLevelsEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SkillRow_company">;
    readonly " $refType": "SkillCategoryRow_company";
};
export type SkillCategoryRow_company$data = SkillCategoryRow_company;
export type SkillCategoryRow_company$key = {
    readonly " $data"?: SkillCategoryRow_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SkillCategoryRow_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillCategoryRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillLevelsEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillRow_company"
    }
  ],
  "type": "Company"
};
(node as any).hash = 'ffa5bb312392142666072110e8350581';
export default node;
